// client/src/components/pages/LexiStar/Messages/MessageAtoms.jsx
//
// Delivery-state chip and channel badge (glyph + word, never colour alone).

import React from 'react';
import { FaWhatsapp, FaTelegramPlane, FaSms, FaBell, FaFlask } from 'react-icons/fa';
import { stateMeta, channelLabel } from './messageMeta';

export function StateChip({ state }) {
  const meta = stateMeta(state);
  return (
    <span
      className={`inline-flex items-center gap-1 px-2 py-0.5 rounded-full text-[11px] font-semibold whitespace-nowrap ${meta.className}`}
      data-state={state}
    >
      <span aria-hidden="true">{meta.glyph}</span>
      {meta.label}
    </span>
  );
}

const CHANNEL_ICONS = {
  whatsapp: FaWhatsapp,
  telegram: FaTelegramPlane,
  sms: FaSms,
  in_app: FaBell,
  fake: FaFlask,
};

export function ChannelBadge({ channel, compact = false }) {
  const Icon = CHANNEL_ICONS[channel];
  return (
    <span className="inline-flex items-center gap-1 text-xs text-slate-700 whitespace-nowrap">
      {Icon && <Icon size={11} aria-hidden="true" className="text-slate-500" />}
      {compact ? <span className="sr-only">{channelLabel(channel)}</span> : channelLabel(channel)}
    </span>
  );
}
